import * as React from "react";

export function CacaoPointComponent(): JSX.Element {
  return (
    <i className="fa fa-circle text-orange-500" aria-hidden="true"></i>
  );
}
